{
  "version": 1,
  "gameId": "othello",
  "economy": {
    "offlineEntryCoins": 0,
    "offlineWinCoins": 0,
    "offlineWinXp": 20,
    "offlineLossXp": 0,
    "onlineEntryCoins": 0,
    "onlineWinCoins": 0,
    "onlineWinXp": 0,
    "onlineLossXp": 0
  },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "othello.rules.navigationLabel",
    "kickerKey": "othello.rules.kicker",
    "titleKey": "othello.rules.title",
    "summaryKey": "othello.rules.summary",
    "sections": [
      { "id": "setup", "key": "othello.rules.setup" },
      { "id": "legal-move", "key": "othello.rules.legalMove" },
      { "id": "flipping", "key": "othello.rules.flipping" },
      { "id": "turns", "key": "othello.rules.turns" },
      { "id": "finish", "key": "othello.rules.finish" },
      { "id": "modes", "key": "othello.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic-green", "nameKey": "othello.theme.classicGreen", "price": 0, "image": "/assets/boards/Otello/classic-green.webp" },
      { "id": "golden-ornate", "nameKey": "othello.theme.goldenOrnate", "price": 500, "image": "/assets/boards/Otello/golden-ornate.webp" },
      { "id": "golden", "nameKey": "othello.theme.golden", "price": 320, "image": "/assets/boards/Otello/golden.webp" },
      { "id": "metal-dark", "nameKey": "othello.theme.metalDark", "price": 180, "image": "/assets/boards/Otello/metal-dark.webp" },
      { "id": "metal", "nameKey": "othello.theme.metal", "price": 210, "image": "/assets/boards/Otello/metal.webp" },
      { "id": "fire", "nameKey": "othello.theme.fire", "price": 360, "image": "/assets/boards/Otello/fire.webp" },
      { "id": "fabric", "nameKey": "othello.theme.fabric", "price": 90, "image": "/assets/boards/Otello/fabric.webp" },
      { "id": "icy", "nameKey": "othello.theme.icy", "price": 240, "image": "/assets/boards/Otello/icy.webp" },
      { "id": "neon", "nameKey": "othello.theme.neon", "price": 400, "image": "/assets/boards/Otello/neon.webp" },
      { "id": "stone", "nameKey": "othello.theme.stone", "price": 160, "image": "/assets/boards/Otello/stone.webp" },
      { "id": "sci-fi-blue", "nameKey": "othello.theme.sciFiBlue", "price": 440, "image": "/assets/boards/Otello/sci-fi-blue.webp" },
      { "id": "wood-golden", "nameKey": "othello.theme.woodGolden", "price": 280, "image": "/assets/boards/Otello/wood-golden.webp" },
      { "id": "wood", "nameKey": "othello.theme.wood", "price": 120, "image": "/assets/boards/Otello/wood.webp" }
    ]
  }
}
